import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useEffect, useRef, useState } from "react";

import { ArrowBigDown } from "lucide-react";
import BaseUrl from "../../../../constants/BaseUrl";
import TerminationPopUp from "../../../popup/terminationPopUp";
import Breadcrumbs from "../../../reusebale/breadcrumbs";
import ButtonTag from "../../../reusebale/button";
import ImageTag from "../../../reusebale/imageTag";
import ParagraphTag from "../../../reusebale/Paragraph";
import LeaseLoader from "../../../skeleton-loader/lease-detail";
import Agreement from "../../../template/flexIndustrialLeaseAgreementSample";
import MaintenanceRequestSection from "../../home/maintainance-request";
import ReceivePayment from "../../home/receivePayment";
import TransactionsTable from "../../home/transactionsTable";
import Chat from "../../leases/leaseDetail/chat";
import CompanyInfo from "./company-info";
import PropertyInfo from "./propertyInfo";
import RentBreakDown from "./rentBreakDown";
import RentScheduleTable from "./rentScheduleTable";
import TenantInfo from "./tenantInfo";
import TerminationReason from "./terminationReason";

import db from "../../../../db/index.json";

import { useSelector } from "react-redux";

import { ShowError, ShowSuccess } from "../../../../utils/ToasFunction";

const DetailLeaseMain = ({
  onBack,
  showDetailStatus,
  recordId,
  onViewDetailsMaintain,
  onMaintainancePage,
  onTriggerCard,
  onEditLease,
  toggleTenantTable,
}) => {
  const { lease } = db;
  const { loginSuccess } = useSelector((state) => state.auth);

  const [leaseDetails, setLeaseDetails] = useState([]);
  const [termLoader, setTermLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tenantInfo, setTenantInfo] = useState();
  const [terminationModal, setTermiinationModal] = useState(false);
  const [showTransactions, setShowTransactions] = useState(false);
  const [llNotes, setLlNotes] = useState("");

  const GetTenantProfile = (id) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${BaseUrl}tenant/profile/getProfileDetails/${id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          setTenantInfo(result.data);
        }
      })
      .catch((error) => console.error(error));
  };

  const LeaseTerminationHandler = (reason, refund, securityDepositRefund, totalAmount) => {
    setTermLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      leaseId: leaseDetails?._id,
      status: "terminated",
      terminationReason: reason,
      refundAmount: Number(refund) || 0,
      securityDepositRefund: Number(securityDepositRefund) || 0,
      totalAmount: Number(totalAmount) || 0,
    });

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/lease/leaseTermination`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          setTermiinationModal(false);
          setTermLoader(false);
          ShowSuccess("Lease status updated successfully");
          onBack();
        } else {
          setTermLoader(false);
          ShowError("Oops! something went wrong");
        }
      })
      .catch((error) => console.error(error));
  };

  const GetLeaseDetails = (isLoad) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    if (isLoad) {
      setLoading(true);
    }
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/lease/getLeaseDetails/${recordId}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          GetTenantProfile(result.data.tenantInfo._id);
          setLoading(false);
          setLeaseDetails(result.data);
        } else {
          ShowSuccess(result.message);
          setLoading(false);
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      GetLeaseDetails(false);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    GetLeaseDetails(true);
  }, []);

  const ChatUpdateHandler = (info) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      leaseId: leaseDetails?._id,
      sender: info.sender,
      text: info.text,
      senderType: info.senderType,
      time: info.time,
    });

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/lease/updateLeaseConversation`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // if (result.status === 200) {
        //   GetLeaseDetails(true);
        // }
      })
      .catch((error) => console.error(error));
  };

  const agreementRef = useRef();

  const generatePDF = () => {
    if (!agreementRef?.current) return;

    // Apply temporary styling fixes
    const applyTemporaryStyles = () => {
      const content = agreementRef.current;
      if (!content) return {};

      // Store original styles to restore later
      const originalStyles = new Map();

      // Save and set the root document container to full width for PDF
      originalStyles.set('root-container', {
        element: content,
        width: content.style.width,
        padding: content.style.padding,
      });
      
      // Set to full A4 width for PDF generation
      content.style.width = '190mm';
      content.style.padding = '15mm';

      // Find heading elements that might have border issues
      const headings = content.querySelectorAll("h1, h2, h3, .title, .heading");

      headings.forEach((heading, index) => {
        // Save original styles
        originalStyles.set(`heading-${index}`, {
          element: heading,
          padding: heading.style.padding,
          margin: heading.style.margin,
          lineHeight: heading.style.lineHeight,
          position: heading.style.position,
          zIndex: heading.style.zIndex,
        });

        // Apply temporary fixes
        heading.style.padding = "15px 0";
        heading.style.margin = "15px 0";
        heading.style.lineHeight = "1.5";
        heading.style.position = "relative";
        heading.style.zIndex = "2";
      });

      return originalStyles;
    };

    // Restore original styles after PDF generation
    const restoreStyles = (originalStyles) => {
      originalStyles.forEach((styles, key) => {
        const { element, padding, margin, lineHeight, position, zIndex, width } = styles;
        
        // Restore all saved properties
        if (width !== undefined) element.style.width = width;
        if (padding !== undefined) element.style.padding = padding;
        if (margin !== undefined) element.style.margin = margin;
        if (lineHeight !== undefined) element.style.lineHeight = lineHeight;
        if (position !== undefined) element.style.position = position;
        if (zIndex !== undefined) element.style.zIndex = zIndex;
      });
    };

    // Apply temporary styles and store original values
    const originalStyles = applyTemporaryStyles();

    // Generate PDF with improved settings
    html2canvas(agreementRef.current, {
      allowTaint: true,
      useCORS: true,
      scale: 2, // Higher scale for better quality
      logging: false,
      height: agreementRef.current.scrollHeight,
      width: agreementRef.current.scrollWidth,
      windowHeight: agreementRef.current.scrollHeight + 100,
      windowWidth: agreementRef.current.scrollWidth,
      imageTimeout: 15000,
      letterRendering: true,
      backgroundColor: "#FFFFFF",
      removeContainer: false,
      foreignObjectRendering: false,
    })
      .then((canvas) => {
        // Restore original styles immediately after canvas is generated
        restoreStyles(originalStyles);

        const doc = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: "a4",
          compress: true,
        });

        const pageWidth = 210; // A4 page width in mm
        const pageHeight = 297; // A4 page height in mm
        const margin = 10; // Standard margins
        const contentWidth = pageWidth - 2 * margin; // 190mm (matches component width)
        const contentHeight = pageHeight - 2 * margin; // Available height per page

        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;

        // Detect actual content height by finding the bottom-most non-white pixel
        let actualContentHeight = canvasHeight;
        const ctx = canvas.getContext('2d');
        const imageData = ctx.getImageData(0, 0, canvasWidth, canvasHeight);
        const data = imageData.data;
        
        // Scan from bottom to top to find where content ends
        for (let y = canvasHeight - 1; y >= 0; y--) {
          let hasContent = false;
          for (let x = 0; x < canvasWidth; x++) {
            const idx = (y * canvasWidth + x) * 4;
            // Check if pixel is not white (allowing for slight variations)
            if (data[idx] < 250 || data[idx + 1] < 250 || data[idx + 2] < 250) {
              hasContent = true;
              break;
            }
          }
          if (hasContent) {
            actualContentHeight = y + 1; // Add 1 to include this row
            break;
          }
        }

        // Calculate image dimensions maintaining aspect ratio
        // Use full content width (190mm) to fill the PDF page
        const imgWidth = contentWidth;
        // Use actual content height instead of full canvas height
        const imgHeight = (actualContentHeight * contentWidth) / canvasWidth;

        // Calculate how many pages we need
        const totalPages = Math.ceil(imgHeight / contentHeight);

        // Add content across multiple pages
        let yPosition = 0;

        for (let i = 0; i < totalPages; i++) {
          if (i > 0) {
            doc.addPage(); // Add a new page for subsequent pages
          }

          // Calculate the height for this page - use actual remaining content
          const remainingHeight = imgHeight - yPosition;
          const pageImgHeight = Math.min(remainingHeight, contentHeight);
          
          // Only proceed if there's actual content to add
          if (pageImgHeight <= 0) break;
          
          // Calculate the source Y position in pixels
          const sourceY = (yPosition / imgHeight) * canvasHeight;
          const sourceHeight = (pageImgHeight / imgHeight) * canvasHeight;

          // Create a temporary canvas for this page's portion
          const pageCanvas = document.createElement('canvas');
          pageCanvas.width = canvasWidth;
          pageCanvas.height = sourceHeight;
          const pageCtx = pageCanvas.getContext('2d');
          pageCtx.drawImage(
            canvas,
            0, sourceY, canvasWidth, sourceHeight, // Source rectangle
            0, 0, canvasWidth, sourceHeight // Destination rectangle
          );

          // Add the page image to PDF - only use the actual content height
          doc.addImage(
            pageCanvas.toDataURL("image/jpeg", 1.0),
            "JPEG",
            margin,
            margin,
            imgWidth,
            pageImgHeight
          );

          yPosition += pageImgHeight;
          
          // If we've added all content, break early
          if (yPosition >= imgHeight) break;
        }

        // Save the PDF
        doc.save("lease-agreement.pdf");
      })
      .catch((error) => {
        console.error("PDF generation error:", error);
        // Restore styles even if there's an error
        restoreStyles(originalStyles);
        alert("There was an error generating the PDF. Please try again.");
      });
  };

  if (showTransactions) {
    return (
      <TransactionsTable
        onBack={() => setShowTransactions(false)}
        leaseId={leaseDetails?._id}
      />
    );
  }

  return (
    <div>
      <div className="mt-5 w-full parent">
        <div className="flex w-full justify-between">
          <div className="flex items-center gap-4 justify-center">
            <Breadcrumbs
              classes={`text-darkColor font-popinsSemiBold text-xl`}
              subheading="Lease Details"
              onBack={onBack}
              recordId={`LES-${recordId?.slice(0, 10)}`}
            />
            {leaseDetails?.status && (
              <div
                className={`px-3 py-1 rounded-full text-xs font-popinsSemiBold ${
                  leaseDetails.status === "active"
                    ? "bg-green-100 text-green-800 border border-green-200"
                    : leaseDetails.status === "terminated"
                    ? "bg-red-100 text-red-800 border border-red-200"
                    : leaseDetails.status === "completed"
                    ? "bg-blue-100 text-blue-800 border border-blue-200"
                    : leaseDetails.status === "draft"
                    ? "bg-yellow-100 text-yellow-800 border border-yellow-200"
                    : leaseDetails.status === "rejected"
                    ? "bg-red-100 text-red-800 border border-red-200"
                    : leaseDetails.status === "inActive"
                    ? "bg-gray-200 text-gray-800 border border-gray-400"
                    : leaseDetails.status === "pendingPayment"
                    ? "bg-amber-100 text-amber-800 border border-amber-200"
                    : "bg-gray-200 text-gray-800 border border-gray-400"
                }`}
              >
                {leaseDetails.status.charAt(0).toUpperCase() +
                  leaseDetails.status.slice(1)}
              </div>
            )}
          </div>
          {showDetailStatus === "active" &&
            leaseDetails?.status !== "completed" && (
              <div className="pt-4 w-40">
                <ButtonTag
                  onSubmit={() => {
                    setTermiinationModal(true);
                  }}
                  name="Lease Termination"
                  classes="text-sm text-center bg-dangerColor text-white"
                />
              </div>
            )}
        </div>

        {showDetailStatus === "active" ? (
          <div className="mb-5">
            <div className="flex h-full justify-between mt-5">
              <div className="w-[64%]  rounded-lg h-full">
                <div className="mb-5">
                  {tenantInfo && <CompanyInfo data={tenantInfo} leaseDetails={leaseDetails} />}
                </div>
                <RentScheduleTable leaseDetails={leaseDetails} />
                <div className="h-[100px] mt-5">
                  <div className="bg-[#FAF2EC] flex px-5 h-full items-center rounded-lg">
                    <div className="w-[50%] flex items-center">
                      <ImageTag
                        path="/assets/daashboard/pdf.png"
                        classes="w-[50px] h-[45px]"
                        altText="logo"
                      />
                      <div className="pl-2">
                        <ParagraphTag
                          content="Signed Leases 2024.pdf"
                          classes="text-darkColor font-popinsSemiBold text-xs"
                        />
                        <ParagraphTag
                          content={`This Rental Lease Agreement (“Agreement”) is entered into on this ${new Date(
                            leaseDetails?.tenantInfo?.startDate
                          ).toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" })}, by and between ${
                            loginSuccess?.user?.firstName
                          } ${loginSuccess?.user?.lastName} (“Landlord”) and  ${
                            leaseDetails?.tenantInfo?.firstName
                          } ${
                            leaseDetails?.tenantInfo?.lastName
                          } (“Tenant”). This Agreement is legally binding under the laws of the United States of America.`}
                          classes="text-darkColor font-popinsMedium text-[10px] line-clamp-2 pt-[2px]"
                        />
                        <div className="flex pt-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="13"
                            viewBox="0 0 12 13"
                            fill="none"
                          >
                            <path
                              d="M3.20915 1.01507C3.20915 0.60703 3.54519 0.246997 3.97723 0.246997C4.38526 0.246997 4.7453 0.60703 4.7453 1.01507V1.78314H7.81758V1.01507C7.81758 0.60703 8.15362 0.246997 8.58566 0.246997C8.99369 0.246997 9.35373 0.60703 9.35373 1.01507V1.78314H10.5058C11.1299 1.78314 11.6579 2.31119 11.6579 2.93525V4.08736H0.90494V2.93525C0.90494 2.31119 1.40899 1.78314 2.05705 1.78314H3.20915V1.01507ZM11.6579 4.85543V11.384C11.6579 12.0321 11.1299 12.5361 10.5058 12.5361H2.05705C1.40899 12.5361 0.90494 12.0321 0.90494 11.384V4.85543H11.6579Z"
                              fill="#FF814E"
                            />
                          </svg>
                          <ParagraphTag
                            content="10/09/2023"
                            classes="text-darkColor/40 font-popinsRegular text-xs pl-1"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="w-[50%] flex justify-end items-center">
                      <button
                        onClick={generatePDF}
                        className="border-2 border-themeColor flex justify-center items-center px-4 h-9 rounded-lg"
                      >
                        <ArrowBigDown color="#0381CA" size={20} />
                        <span className="text-themeColor font-popinsRegular text-xs pl-1">
                          Download Document
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-[34%] h-full">
                <div className="bg-white rounded-lg px-5">
                  <RentBreakDown leaseDetails={leaseDetails} />
                </div>
              </div>
            </div>

            <div className="flex justify-between mt-5">
              <div className="w-full">
                <PropertyInfo leaseDetails={leaseDetails} />
              </div>
            </div>
            <div className="flex justify-between mt-5">
              <div className="w-[49%]">
                <MaintenanceRequestSection
                  onViewDetails={onViewDetailsMaintain}
                  onMaintainanceTable={onMaintainancePage}
                />
              </div>
              <div className="w-[49%]">
                <ReceivePayment
                  leaseDetails={leaseDetails}
                  handleTenantaTable={toggleTenantTable}
                  onViewAllTransactions={(leaseId) => {
                    setShowTransactions(true);
                  }}
                />
              </div>
            </div>
            <div className="flex flex-wrap mt-5" id="gk-cards"></div>
          </div>
        ) : (
          <div className="h-screen">
            {loading && <LeaseLoader />}
            {!loading && (
              <div className="flex justify-between h-full">
                <div className="w-[59%] h-screen overflow-scroll scrollbar-hide panelScroll py-5">
                  {tenantInfo && <CompanyInfo data={tenantInfo} leaseDetails={leaseDetails} />}
                  {leaseDetails.status === "terminated" && (
                    <div className="mt-5">
                      <TerminationReason
                        reason={leaseDetails.terminationReason}
                        amount={leaseDetails.refundAmount}
                        data={tenantInfo}
                        leaseId={leaseDetails._id}
                        onViewAllTransactions={(leaseId) => {
                          setShowTransactions(true);
                        }}
                      />
                    </div>
                  )}
                  {leaseDetails.status === "completed" && (
                    <div className="mt-5">
                      <div className="bg-white rounded-xl p-2">
                        <div className="px-4 pt-4">
                          <ParagraphTag
                            content="Lease Completed"
                            classes="text-darkColor font-popinsSemiBold text-lg mt-[-3px]"
                          />
                          <ParagraphTag
                            content="This lease has been successfully completed. The tenant has fulfilled all rental obligations and the tenancy has officially ended. You can now prepare this property for future rentals."
                            classes="text-gray-600 font-popinsRegular text-sm leading-relaxed"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="mt-5">
                    <PropertyInfo leaseDetails={leaseDetails} />
                  </div>
                  <div className="mt-5">
                    <RentScheduleTable leaseDetails={leaseDetails} />
                  </div>
                  <div className="mt-5 bg-white rounded-lg">
                    <div className="h-[100px]">
                      <div className="bg-[#FAF2EC] flex px-5 h-full items-center rounded-lg">
                        <div className="w-[50%] flex items-center">
                          <ImageTag
                            path="/assets/daashboard/pdf.png"
                            classes="w-[50px] h-[45px]"
                            altText="logo"
                          />
                          <div className="pl-2">
                            <ParagraphTag
                              content="Signed Leases 2024.pdf"
                              classes="text-darkColor font-popinsSemiBold text-xs"
                            />
                            <ParagraphTag
                              content={`This Rental Lease Agreement (“Agreement”) is entered into on this ${new Date(
                                leaseDetails?.tenantInfo?.startDate
                              ).toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" })}, by and between ${
                                loginSuccess?.user?.firstName
                              } ${
                                loginSuccess?.user?.lastName
                              } (“Landlord”) and  ${
                                leaseDetails?.tenantInfo?.firstName
                              } ${
                                leaseDetails?.tenantInfo?.lastName
                              } (“Tenant”). This Agreement is legally binding under the laws of the United States of America.`}
                              classes="text-darkColor font-popinsMedium text-[10px] line-clamp-2 pt-[2px]"
                            />
                            <div className="flex pt-1">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="13"
                                viewBox="0 0 12 13"
                                fill="none"
                              >
                                <path
                                  d="M3.20915 1.01507C3.20915 0.60703 3.54519 0.246997 3.97723 0.246997C4.38526 0.246997 4.7453 0.60703 4.7453 1.01507V1.78314H7.81758V1.01507C7.81758 0.60703 8.15362 0.246997 8.58566 0.246997C8.99369 0.246997 9.35373 0.60703 9.35373 1.01507V1.78314H10.5058C11.1299 1.78314 11.6579 2.31119 11.6579 2.93525V4.08736H0.90494V2.93525C0.90494 2.31119 1.40899 1.78314 2.05705 1.78314H3.20915V1.01507ZM11.6579 4.85543V11.384C11.6579 12.0321 11.1299 12.5361 10.5058 12.5361H2.05705C1.40899 12.5361 0.90494 12.0321 0.90494 11.384V4.85543H11.6579Z"
                                  fill="#FF814E"
                                />
                              </svg>
                              <ParagraphTag
                                content="10/09/2023"
                                classes="text-darkColor/40 font-popinsRegular text-xs pl-1"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="w-[50%] flex justify-end items-center">
                          <button
                            onClick={generatePDF}
                            className="border-2 border-themeColor flex justify-center items-center px-4 h-9 rounded-lg"
                          >
                            <ArrowBigDown color="#0381CA" size={20} />
                            <span className="text-themeColor font-popinsRegular text-xs pl-1">
                              Download Document
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white rounded-lg mt-5">
                    <RentBreakDown leaseDetails={leaseDetails} />
                  </div>
                  {!["active", "terminated"].includes(showDetailStatus) && (
                    <div className="pt-4">
                      <ButtonTag
                        onSubmit={() => {
                          onEditLease(leaseDetails);
                        }}
                        name="Modify Lease"
                        classes="text-sm text-center bg-themeColor text-white"
                      />
                    </div>
                  )}
                </div>

                <div className="w-[39%] pt-5 h-full flex flex-col gap-4">
                  <Chat
                    termiinated={
                      showDetailStatus === "terminated" ? true : false
                    }
                    chatUpdateHandler={ChatUpdateHandler}
                    leaseDetails={leaseDetails}
                  />
                  {/* Notes — internal LL use only */}
                  <div className="bg-white rounded-xl p-4">
                    <p className="text-darkColor font-popinsSemiBold text-sm">Notes</p>
                    <p className="text-darkColor/40 font-popinsRegular text-[10px] mb-2">For internal landlord use only</p>
                    <textarea
                      value={llNotes}
                      onChange={(e) => setLlNotes(e.target.value)}
                      rows={4}
                      placeholder="Add your private notes here..."
                      className="w-full text-sm bg-bgColor border border-gray-200 font-popinsRegular px-3 py-2 rounded-md text-darkColor placeholder:text-gray-400 focus:outline-none focus:border-themeColor resize-none"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      {/* Agreement rendered off-screen for PDF generation */}
      <div style={{ position: "absolute", left: "-9999px", top: 0, pointerEvents: "none" }}>
        <Agreement
          ref={agreementRef}
          tenentInfo={leaseDetails?.tenantInfo}
          data={leaseDetails}
        />
      </div>

      {terminationModal && (
        <TerminationPopUp
          loading={termLoader}
          onSubmit={(reason, refund, securityDepositRefund, totalAmount) => {
            LeaseTerminationHandler(reason, refund, securityDepositRefund, totalAmount);
          }}
          onClose={() => {
            setTermiinationModal(false);
          }}
        />
      )}
    </div>
  );
};

export default DetailLeaseMain;
